import { Box, Grid, TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { AppRouteURI } from "router/RoleBasedAccess";
import useStyles from "../Styles";
import { Typography, Button } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useSelector } from "react-redux";
import userActions from '../../TechnicalView/actions'
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import ToolbarButtons from "./ToolbarButtons";
import useIsDevUrl from "hooks/useIsDevUrl";
import HomeSharpIcon from '@material-ui/icons/HomeSharp';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { setItem } from '../../../local-store'
import './header.css'

const excludeEntityNameScreens = ["scenario", "members", "invites", "settings", "feature_settings", "security", "reset_password"];

const HeaderView = () => {
  const classes = useStyles();
  const history = useHistory();
  // const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const { loggedIn } = useSelector((state) => state.auth);
  const { chart, all_scenarios, scenario_selected, entity_header  } = useSelector((state) => state.technical_view);

  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open = Boolean(anchorEl);
  const isDevUrl = useIsDevUrl();
  const [title, setTitle] = useState('')
  // const id = open ? "user-settings" : null;
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  // const { user } = useSelector((state) => state.settings.profile);
  // const { setDrawerState } = appActions();
  const { isMobile } = useGetViewPortDimensions();
  const { setScenarioSelected } = userActions();
  const pages = [
    // {
    //   title: "Home",
    //   route: AppRouteURI.SCENARIO,
    // },
    // {
    //   title: "Water User",
    //   route: AppRouteURI.WATER_USER,
    //   children: [
    //     {
    //       title: "Cities",
    //       route: AppRouteURI.WATER_USER + "/cities",
    //     },
    //     {
    //       title: "Tribes",
    //       route: AppRouteURI.WATER_USER + "/tribes",
    //     },
    //     {
    //       title: "Agriculture",
    //       route: AppRouteURI.WATER_USER + "/agriculture",
    //     },
    //     {
    //       title: "Industry",
    //       route: AppRouteURI.WATER_USER + "/industry",
    //     },
    //   ],
    // },
    // {
    //   title: 'Arizona',
    //   route: AppRouteURI.ARIZONA
    // },
    // {
    //   title: "Central Arizona",
    //   route: AppRouteURI.CENTRAL_ARIZONA,
    // },
    // {
    //   title: "Public View",
    //   route: AppRouteURI.PUBLIC + AppRouteURI.PUBLIC_MAP_VIZ,
    // },
  ];
  // const settings = ["Profile", "Account", "Dashboard", "Logout"];

  const handleAutoCompleteScenario = (e, v) => {
    if (v !== null) handleSelectedScenario(v);
  };

  const handleSelectedScenario = (e) => {
    setItem(e, 'dropdownData')
    setScenarioSelected(e);
  };

  const selectChart = () => {
    const { location } = history || {}
    if(location?.pathname?.includes('scenario')) {
      setTitle('Choose a Scenario')
      return
    }
    if(chart && location?.pathname?.includes('visualizations')) {
      switch(chart) {
        case 'colorado_river_access': 
          setTitle('Colorado River Access') 
          break;
        case 'access_per_capita': 
          setTitle('Colorado River Access Per Person - Cities')
          break;
        case 'central_az_water_use': 
          setTitle('Central Arizona Water Deliveries & Uses - 2020')
          break;
        case 'colorado_river_water_access': 
          setTitle('Colorado River Water Access')
          break;
        case 'water_use_versus_access': 
          setTitle('Colorado River Water Use versus Access')
          break;
        default: return
      }
    }
  }

  useEffect(selectChart, [chart])


  const displayRightContent = (
    <>
      {
        title && history?.location?.pathname?.includes('visualizations') ? (
          <Box style={{ display: 'flex', alignItems: 'center' , marginRight: '16px' }}>
            <Autocomplete
              id="location-select"
              value={all_scenarios.find((scenario_option) => scenario_option.value === scenario_selected.value) || {}}
              options={all_scenarios}
              renderOption={(option) =>  <div><b>{option.label}</b>: {option.description}</div>}
              getOptionLabel={(option) => option.label || ""}
              onChange={handleAutoCompleteScenario}
              disabled ={false}
              style={{ width:690 }}
              renderInput={(params) => (
                <TextField {...params} variant="filled" className={classes.autoComplete} style={{background: 'white', padding: '0px', borderRadius: '16px' }} />
              )}
            />
          </Box>
        ) : ''
      }
        <Box className={classes.asuLogo}>
          {loggedIn && <ToolbarButtons />}
      </Box>
    </>
  )

  return (
    <Grid className={classes.header} container>
      <Box
        className={
          isMobile
            ? classes.headerBackgroundBoxResponsive
            : classes.headerBackgroundBox
        }
      >
        {/* <Container maxWidth="xl" > */}
        {/* <Toolbar className={classes.headerToolBar} disableGutters> */}
        <Box
          className={
            isMobile ? classes.headerTextBoxResponsive : classes.headerTextBox
          }
          onClick={() => history.push(AppRouteURI.HOME)}
        >
          <HomeSharpIcon className={classes.homeIcon} />
        </Box>
        <Box className={classes.headerTitle}>
          {title}   
        </Box>
        {
        !excludeEntityNameScreens.some(el =>  history?.location?.pathname?.includes(el)) ? (
        <Box className={`${classes.headerTitleEntity} ${entity_header?.length < 62 ? classes.alignHeaderCenter : ''}`}>
          <div className={classes.entityHeaderContainer}>
            <div className={classes.entityHeaderText}>
            {
              `Entity: ${entity_header}`  
            }  
            </div>
          </div>
        </Box>
        ) : ''
      }

        {!isMobile
          ? pages.map((item, idx) => (
              <NavLink
                to={item.route && !isDevUrl ? item.route : "/"}
                className={classes.navLink}
              >
                <Grid
                  xs={12}
                  md={2}
                  classes={{ root: classes.headerItems }}
                  item
                >
                  <Box className={classes.headerBox}>
                    <Button classes={{ root: classes.headerItemButton }}>
                      <Typography
                        className={classes.headerItemText}
                        style={
                          item.hasOwnProperty("children")
                            ? { paddingLeft: 12 }
                            : {}
                        }
                      >
                        {item.title}{" "}
                        {item.hasOwnProperty("children") ? (
                          <ArrowDropDownIcon
                            className={classes.arrowDownIcon}
                          />
                        ) : (
                          ""
                        )}
                      </Typography>
                    </Button>
                  </Box>
                  {item.hasOwnProperty("children") ? (
                    <div className={classes.subNav}>
                      <ul>
                        {item.children.map((child, idx2) => (
                          <NavLink to={child.route} className={classes.subLink}>
                            <li>{child.title}</li>
                          </NavLink>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
              </NavLink>
            ))
          : null}

        {/* </Toolbar> */}

        <Grid xs={12} md={12} className={classes.headerLogo} item>
          {displayRightContent}
        </Grid>
        {/* </Container> */}
      </Box>
    </Grid>
  );
};

export default HeaderView;
